import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGridOperators } from 'app/entities/grid-operator/grid-operator.reducer';
import { SwitchingStatus } from 'app/shared/model/enumerations/switching-status.model';
import { createEntity, getEntity, reset, updateEntity } from './ean.reducer';

export const EanUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const gridOperators = useAppSelector(state => state.gridOperator.entities);
  const eanEntity = useAppSelector(state => state.ean.entity);
  const loading = useAppSelector(state => state.ean.loading);
  const updating = useAppSelector(state => state.ean.updating);
  const updateSuccess = useAppSelector(state => state.ean.updateSuccess);
  const switchingStatusValues = Object.keys(SwitchingStatus);

  const handleClose = () => {
    navigate('/ean');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGridOperators({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.eanCode !== undefined && typeof values.eanCode !== 'number') {
      values.eanCode = Number(values.eanCode);
    }

    const entity = {
      ...eanEntity,
      ...values,
      gridOperator: gridOperators.find(it => it.id.toString() === values.gridOperator?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          switchingStatus: 'SWITCH',
          ...eanEntity,
          gridOperator: eanEntity?.gridOperator?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.ean.home.createOrEditLabel" data-cy="EanCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.ean.home.createOrEditLabel">Create or edit a Ean</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ean-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.ean.eanCode')}
                id="ean-eanCode"
                name="eanCode"
                data-cy="eanCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.switchingStatus')}
                id="ean-switchingStatus"
                name="switchingStatus"
                data-cy="switchingStatus"
                type="select"
              >
                {switchingStatusValues.map(switchingStatus => (
                  <option value={switchingStatus} key={switchingStatus}>
                    {translate(`crawlerBackendApp.SwitchingStatus.${switchingStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.ean.isResidential')}
                id="ean-isResidential"
                name="isResidential"
                data-cy="isResidential"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.isComplex')}
                id="ean-isComplex"
                name="isComplex"
                data-cy="isComplex"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.isSmartMeter')}
                id="ean-isSmartMeter"
                name="isSmartMeter"
                data-cy="isSmartMeter"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.gridArea')}
                id="ean-gridArea"
                name="gridArea"
                data-cy="gridArea"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.bagId')}
                id="ean-bagId"
                name="bagId"
                data-cy="bagId"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.bagBuildingId')}
                id="ean-bagBuildingId"
                name="bagBuildingId"
                data-cy="bagBuildingId"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.ean.activeMeterNumber')}
                id="ean-activeMeterNumber"
                name="activeMeterNumber"
                data-cy="activeMeterNumber"
                type="text"
              />
              <ValidatedField
                id="ean-gridOperator"
                name="gridOperator"
                data-cy="gridOperator"
                label={translate('crawlerBackendApp.ean.gridOperator')}
                type="select"
              >
                <option value="" key="0" />
                {gridOperators
                  ? gridOperators.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ean" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EanUpdate;
